import { ReactNode } from "react";
import MobileTabHeading from "./MobileTabHeading";
import DocumentPaper3Lines from "@svg/new-design/document-paper-3-lines";

const MobileResearchPanel = ({
  parsedContent,
}: {
  parsedContent: ReactNode;
}) => {
  return (
    <div className="py-6">
      <MobileTabHeading
        icon={DocumentPaper3Lines}
        title="زمینه های پژوهشی و آموزشی"
      />
      <div className="pt-4 body-sm text-fds-secondary">{parsedContent}</div>
    </div>
  );
};

export default MobileResearchPanel;
